import {
  Phone, FileCheck, DollarSign, TrendingUp, Target,
} from "lucide-react";
import { formatCurrency } from "../lib/format";

// ─── Lock bypass flag ─────────────────────────────────────────────────────────
// true  → Training & Goals tabs are always unlocked (test mode)
// false → gating restores: both tabs require all docs signed
export const BYPASS_LOCK = true;

// ─── Color map ────────────────────────────────────────────────────────────────
export const COLOR_CLASS_MAP = {
  blue:   "#2563eb",
  purple: "#7c3aed",
  green:  "#16a34a",
  orange: "#ea580c",
};

// ─── Icon resolver ────────────────────────────────────────────────────────────
// Maps a string name (stored in JSON) to a Lucide icon element.
export function resolveIcon(name, size = 18, color = "#64748b") {
  const map = {
    phone:     <Phone      size={size} color={color} />,
    filecheck: <FileCheck  size={size} color={color} />,
    dollar:    <DollarSign size={size} color={color} />,
    trending:  <TrendingUp size={size} color={color} />,
  };
  return map[name] ?? <Target size={size} color={color} />;
}

// ─── Value formatter ──────────────────────────────────────────────────────────
// Wraps lib/format so components don't need to know the format string.
export function formatMetricValue(value, format) {
  if (format === "currency") return formatCurrency(value, { compact: true });
  return `${value}`;
}

// ─── Progress bar color ───────────────────────────────────────────────────────
export function progressColor(pct) {
  if (pct >= 100) return "#16a34a";
  if (pct >= 60)  return "#2563eb";
  if (pct >= 30)  return "#f59e0b";
  return "#ef4444";
}